import eikaAccordion from './accordion';
import advisorlistMore from './advisorlist-more';
import closeDynamicCard from './closables';
import comparisonTable from './comparisontable';
import EikaMenuComponent from './header';
import eikaImageZoom from './imagezoom';
import loginDropdown from './logindropdown';
import scriptLoaderEnhanced from './scriptLoaderEnhanced';
import { detectScrollbarWidth } from './scrollbar';
import eikaSidemenu from './sidemenu';
import EikaTooltips from './tooltip';
import loadYoutubeEmbed from './youtubeloader';

import './styles/index.scss';

detectScrollbarWidth();
EikaMenuComponent(document.querySelector('header.header23')!);
closeDynamicCard();
eikaAccordion();
eikaImageZoom();
eikaSidemenu(document.querySelector('.sidemenu')!);
scriptLoaderEnhanced(window.document);
loginDropdown(document.querySelector('#loginbuttondropdown'));
EikaTooltips();
comparisonTable();
loadYoutubeEmbed('.sgw-video-card__media-iframe');
advisorlistMore();
